import { AU_TAX_IDS, AU_TAX_IDS_META } from "./countries/au";
import {
  CA_TAX_IDS,
  CA_TAX_IDS_META,
  CA_VAT_IDS,
  CA_VAT_IDS_META,
} from "./countries/ca";
import {
  DE_TAX_IDS,
  DE_TAX_IDS_META,
  DE_VAT_IDS,
  DE_VAT_IDS_META,
} from "./countries/de";
import { ES_TAX_IDS, ES_TAX_IDS_META } from "./countries/es";
import {
  FR_TAX_IDS,
  FR_TAX_IDS_META,
  FR_VAT_IDS,
  FR_VAT_IDS_META,
} from "./countries/fr";
import {
  GB_TAX_IDS,
  GB_TAX_IDS_META,
  GB_VAT_IDS,
  GB_VAT_IDS_META,
} from "./countries/gb";
import { US_TAX_IDS, US_TAX_IDS_META } from "./countries/us";

const TAX_ID_FORM_NAME = "TAX_ID_FORM";
const VAT_ID_FORM_NAME = "VAT_ID_FORM";

// List of supported Tax or Vat IDs (EIN, SSN, VAT, GST_HST etc.)
const TAX_INFORMATION_TYPES = {
  // TAX
  ...US_TAX_IDS,
  ...GB_TAX_IDS,
  ...CA_TAX_IDS,
  ...ES_TAX_IDS,
  ...DE_TAX_IDS,
  ...FR_TAX_IDS,
  ...AU_TAX_IDS,
  // VAT
  ...CA_VAT_IDS,
  ...GB_VAT_IDS,
  ...DE_VAT_IDS,
  ...FR_VAT_IDS,
};

// List of metadata for each TAX_INFORMATION_TYPES item
const TAX_INFORMATION_META = {
  // TAX
  ...US_TAX_IDS_META,
  ...GB_TAX_IDS_META,
  ...CA_TAX_IDS_META,
  ...ES_TAX_IDS_META,
  ...DE_TAX_IDS_META,
  ...FR_TAX_IDS_META,
  ...AU_TAX_IDS_META,
  // VAT
  ...CA_VAT_IDS_META,
  ...GB_VAT_IDS_META,
  ...DE_VAT_IDS_META,
  ...FR_VAT_IDS_META,
};

// List of statuses (saved, required, not_saved)
const TAX_INFORMATION_STATUSES = {
  SAVED: "saved",
  NOT_SAVED: "not_saved",
  REQUIRED: "required",
};

// List of Tax variants (individual or business)
const TAX_ID_VARIANTS = {
  INDIVIDUAL: "individual",
  COMPANY: "company",
};

// Map with tax type by country and variant
const TAX_ID_BY_COUNTRY_MAP = {
  US: {
    [TAX_ID_VARIANTS.INDIVIDUAL]: TAX_INFORMATION_TYPES.SSN_ITIN,
    [TAX_ID_VARIANTS.COMPANY]: TAX_INFORMATION_TYPES.EIN,
  },
  GB: {
    [TAX_ID_VARIANTS.INDIVIDUAL]: TAX_INFORMATION_TYPES.NINO,
    [TAX_ID_VARIANTS.COMPANY]: TAX_INFORMATION_TYPES.CRN,
  },
  CA: {
    [TAX_ID_VARIANTS.INDIVIDUAL]: TAX_INFORMATION_TYPES.SIN,
    [TAX_ID_VARIANTS.COMPANY]: TAX_INFORMATION_TYPES.BN,
  },
  ES: {
    [TAX_ID_VARIANTS.INDIVIDUAL]: TAX_INFORMATION_TYPES.NIF_NIE,
    [TAX_ID_VARIANTS.COMPANY]: TAX_INFORMATION_TYPES.NIF_NIE_CIF,
  },
  DE: {
    [TAX_ID_VARIANTS.INDIVIDUAL]: TAX_INFORMATION_TYPES.STEUERID_STEUERNUMMER,
    [TAX_ID_VARIANTS.COMPANY]: TAX_INFORMATION_TYPES.HANDELSREGISTERNUMMER,
  },
  FR: {
    [TAX_ID_VARIANTS.INDIVIDUAL]: TAX_INFORMATION_TYPES.NUM_FISCAL,
    [TAX_ID_VARIANTS.COMPANY]: TAX_INFORMATION_TYPES.SIREN_SIRET,
  },
  AU: {
    [TAX_ID_VARIANTS.INDIVIDUAL]: TAX_INFORMATION_TYPES.TFN,
    [TAX_ID_VARIANTS.COMPANY]: TAX_INFORMATION_TYPES.ABN_ACN,
  },
};

// Map with vat type by country
const VAT_ID_BY_COUNTRY_MAP = {
  GB: TAX_INFORMATION_TYPES.VAT,
  CA: TAX_INFORMATION_TYPES.GST_HST,
  DE: TAX_INFORMATION_TYPES.UST_IDNR,
  FR: TAX_INFORMATION_TYPES.NUM_TVA,
};

export {
  TAX_ID_FORM_NAME,
  VAT_ID_FORM_NAME,
  TAX_ID_VARIANTS,
  TAX_ID_BY_COUNTRY_MAP,
  VAT_ID_BY_COUNTRY_MAP,
  TAX_INFORMATION_TYPES,
  TAX_INFORMATION_META,
  TAX_INFORMATION_STATUSES,
};
